export default {
      id: "import_my_template-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "img/icons.ea6ea76b.svg#import_my_template",
      toString: function () {
        return this.url;
      }
    }